var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5629 0H0.43327C0.193672 0 0 0.193672 0 0.43327V20.3637C0 20.6033 0.193672 20.797 0.43327 20.797H9.96521V25.1297H8.6654V25.9962H10.3985H15.5977V25.1297H10.8317V20.797H15.1644V19.9304H10.3985H0.86654V16.4643H2.16635H14.7312H15.1644V15.5977H14.7312H2.59962V2.59962H23.3966V9.53194H24.2631V2.16635C24.2631 1.92675 24.0694 1.73308 23.8298 1.73308H2.16635C1.92675 1.73308 1.73308 1.92675 1.73308 2.16635V15.5977H0.86654V0.86654H25.1297V9.53194H25.9962V0.43327C25.9962 0.193672 25.8025 0 25.5629 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5616 11.2695H16.8962C16.6566 11.2695 16.4629 11.4632 16.4629 11.7028V25.5674C16.4629 25.807 16.6566 26.0007 16.8962 26.0007H25.5616C25.8012 26.0007 25.9948 25.807 25.9948 25.5674V11.7028C25.9948 11.4632 25.8012 11.2695 25.5616 11.2695ZM25.1283 12.1361V13.8692H17.3294V12.1361H25.1283ZM25.1283 14.7357V22.9678H17.3294V14.7357H25.1283ZM17.3294 25.1342V23.8344H25.1283V25.1342H17.3294Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0983 12.5703H20.3652V13.4369H22.0983V12.5703Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6305 19.0599H23.8298C24.0694 19.0599 24.263 18.8662 24.263 18.6266V16.027C24.263 15.7874 24.0694 15.5938 23.8298 15.5938H18.6305C18.3909 15.5938 18.1973 15.7874 18.1973 16.027V18.6266C18.1973 18.8662 18.3909 19.0599 18.6305 19.0599ZM19.0638 16.4603H23.3965V18.1934H19.0638V16.4603Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.263 19.9258H18.1973V20.7923H24.263V19.9258Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.263 21.2344H18.1973V22.1009H24.263V21.2344Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5268 8.23081V3.89811C22.5268 3.65852 22.3331 3.46484 22.0935 3.46484H3.89616C3.65656 3.46484 3.46289 3.65852 3.46289 3.89811V8.23081C3.46289 8.47041 3.65656 8.66408 3.89616 8.66408H22.0935C22.3331 8.66408 22.5268 8.47041 22.5268 8.23081ZM21.6602 7.79754H4.32943V4.33138H21.6602V7.79754Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89616 9.53516C3.65656 9.53516 3.46289 9.72883 3.46289 9.96843V14.3011C3.46289 14.5407 3.65656 14.7344 3.89616 14.7344H9.0954C9.335 14.7344 9.52867 14.5407 9.52867 14.3011V9.96843C9.52867 9.72883 9.335 9.53516 9.0954 9.53516H3.89616ZM8.66213 13.8679H4.32943V10.4017H8.66213V13.8679Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8646 9.96875H10.3984V10.8353H13.8646V9.96875Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7311 11.6992H10.3984V12.5658H14.7311V11.6992Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7311 13.4297H10.3984V14.2962H14.7311V13.4297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group (3).149819dea7de4ea8cc80af38cdaad1a1.svg";
export { ForwardRef as ReactComponent };